import { createRouter, createWebHashHistory, createWebHistory, RouteRecordRaw } from 'vue-router'

const modelRoutes = require.context('./model', true, /.ts$/)
const list = modelRoutes.keys().map(_ => {
  const router = modelRoutes(_)
  if (_.indexOf('login') === -1 && _.indexOf('404') === -1) {
    router.default.component = () => import("@/views/layout/home.vue")
  }
  return router.default || _
})

const routes: Array<RouteRecordRaw> = [
  ...list,
  // 注意顺序，根据最新的路由匹配规则，404页面必须在最后，
]

// console.log(JSON.stringify(routes, null, "\t"), '\n', "路由表内容")
const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
